"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { TagsModel } from "./tags.model";
export let ProxyEditModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.auto_proxy = false;
    this.marks = new TagsModel();
    this.proxy_account = "";
    this.proxy_ip = "";
    this.proxy_password = "";
    this.proxy_port = 0;
    this.proxy_protocol = "";
    this.support_remote = false;
  }
};
ProxyEditModel.model = "custom_proxy";
ProxyEditModel = __decorateClass([
  Annotation.ModelMeta
], ProxyEditModel);
